<template>
  <div class="v-login">
    <v-container>
      <v-row v-if="isStaging">
        <v-col class="text-center">
          Staging
        </v-col>
      </v-row>
      <v-row justify="center" v-if="showLoginButton">
        <v-col cols="auto">
          <v-btn
            color="primary darken-1"
            @click.prevent="signIn"
          >
            <v-img
              class="mr-2"
              max-width="25"
              max-height="25"
              src="@/assets/google_logo.svg"
            ></v-img>
            Sign in with Google
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      isStaging: process.env.NODE_ENV === 'staging',
      isDevEnv: process.env.NODE_ENV === 'development',
      identity: null,
      isAuthorized: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    showLoginButton () {
      return !this.user.employee_id
    },
    reportingVersion () {
      return localStorage.getItem('reportingNew') ? 'Reporting New' : 'Reporting'
    }
  },
  methods: {
    loginUserToDCM (code) {
      if (code) {
        this.axios
          .post('/api/googlelogin', {
            code: code
          })
          .then(userData => {
            this.axios
              .post('/api/gettoken', {
                ...userData.data,
                client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID
              })
              .then(res => {
                this.$store.dispatch('setUserData', {
                  userData: {
                    token: res.data.token,
                    refresh_token: res.data.refresh_token,
                    employee_id: userData.data.employee_id,
                    login: userData.data.login,
                    full_name: userData.data.full_name,
                    e_mail: userData.data.e_mail
                  }
                })
                if (this.reportingVersion === 'Reporting New') {
                  localStorage.setItem('reportingNew', JSON.stringify({ CurrentMonth: new Date().toISOString().substring(0, 10) }))
                }
                this.$router.replace({ name: this.reportingVersion })
              })
          })
      }
    },
    signIn () {
      const client = this.$client(this.loginUserToDCM)
      client.requestCode()
    }
  }
}
</script>

<style lang="scss">
.v-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
}
</style>
